module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "epf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "v",
      "epub:type": "pagebreak",
      "id": "pv",
      "role": "doc-pagebreak"
    }
  }), _vm._v("The best place to view Los Angeles of the next millennium is from the ruins of its alternative future.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Mike Davis, "), _c('i', [_vm._v("city of quartz: excavating the future in los angeles")])]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("Trade is our nation’s economic lifeblood. You are helping to keep that lifeblood healthy and running.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Alan Cranston, former US senator from California, in a speech praising the Port of Long Beach")]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("Welcome to San Pedro Bay, home to the nation’s largest port complex and millions of plants and animals . . .")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Port of Los Angeles brochure “Harbor Habitat: Our Biological Treasures”")]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("Infrastructure is the spine of the Wiindigo, but is also the essential architecture of transition to a decolonized future.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Winona LaDuke and Deborah Cowen, “Beyond Wiindigo Infrastructure”")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-372faf60","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-dunbar-hester-0005.vue
// module id = 66
// module chunks = 0